import React, { useContext, useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { QlikUIContext } from '../QlikUIContext'
import { ReportCard } from './ReportCard'
import { useTheme, makeStyles } from '@material-ui/core'
import { stylesMui } from './styles/streamReport.styles'

export const StreamReport = ({
  streamRepo,
  onNewReport,
  onViewReport,
  onEditReport
}) => {
  const context = useContext(QlikUIContext)
  const [isAdmin, setIsAdmin] = useState(false)
  const currentTheme = useTheme()
  const useStyles = makeStyles(stylesMui(currentTheme))
  const classes = useStyles()

  useEffect(() => {
    const roles = context.roles.split(',')
    setIsAdmin(roles.includes('Administracion'))
  }, [])

  function handleNewStreamReport(reportType) {
    onNewReport(reportType, streamRepo.StreamId)
  }

  return (
    <React.Fragment>
      <Grid container direction='row' justify='space-around'>
        <Grid item xs={12}>
          <div className='reports'>
            <div className={classes.gridItemContainer}>
              {isAdmin && (
                <div className={classes.gridItem}>
                  <ReportCard
                    ambitReport={null}
                    newCard={true}
                    onNewStreamReport={handleNewStreamReport}
                    onViewStreamReport={onViewReport}
                    onEditStreamReport={onEditReport}
                  />
                </div>
              )}

              {streamRepo.Reports.map((repo, index) => {
                return (
                  <div className={classes.gridItem} key={index}>
                    <ReportCard
                      ambitReport={repo}
                      newCard={false}
                      onNewStreamReport={handleNewStreamReport}
                      onViewStreamReport={onViewReport}
                      onEditStreamReport={onEditReport}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
